export default "__VITE_ASSET__D09oR_T6__"